import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import FeatherIcon from 'feather-icons-react';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import RequestClaimModal from 'components/modals/RequestClaimModal';

export const tableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row: { original } }) => {
      const { userName, id } = original.user;
      return (
        <div className="d-flex align-items-center">
          <div>
            <Link to={'/users/' + id + '/details'} className="fs-8 fw-bold">
              {userName}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 border-start border-end border-translucent ps-0'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'userId',
    header: 'User ID',
    cell: ({ row: { original } }) => {
      const { userId, id } = original.user;
      return (
        <div className="d-flex align-items-center">
          <div>
            <Link to={'/users/' + id + '/details'} className="fs-8 fw-bold">
              {userId}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 border-start border-end border-translucent ps-0'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'points',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>Points</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { points } = original;
      return <>{points}</>;
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'waterAmount',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>Token</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { tokens } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{tokens}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    id: 'actions',
    cell: ({ row: { original }, table }: any) => {
      const { handleSubmit } = table.options.meta;
      const [status, setStatus] = useState(original.status);
      const [id, setId] = useState(original.id);

      const handleApprove = async (id: number) => {
        setStatus('success');
        handleShow();
      };
      const handleReject = async (id: number) => {
        setStatus('rejected');
        handleShow();
      };

      const [show, setShow] = useState(false);
      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);

      return (
        <>
          <div className="d-flex gap-2 justify-content-end">
            <Button
              variant="success"
              size="sm"
              title="Approve"
              onClick={() => handleApprove(original.id)}
            >
              <FeatherIcon icon="check" size={16} />
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={() => handleReject(original.id)}
              title="Reject"
            >
              <FeatherIcon icon="x" size={16} />
            </Button>
          </div>

          {/* display modal for approve and reject comments */}
          <RequestClaimModal
            show={show}
            id={id}
            status={status}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        </>
      );
    },
    meta: {
      headerProps: {
        style: { width: '10%' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      },
      cellProps: {
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      }
    }
  }
];

const ClaimRequestTable = () => {
  return (
    <div className="border-top border-translucent">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

export default ClaimRequestTable;
